module.exports = __webpack_public_path__ + "static/media/circle-viewall.2f9f7400.svg";